<template>
  <div class="licenses">
    <LicensesList
      v-bind:endpoint="`api/licences`"
      v-bind:actionEndpoint="`api/licences`"
      v-bind:filters="`?customer.id=${customerId}`"
      v-bind:entity="licenseEntity"
      v-bind:editAllowedFields="['customName', 'api', 'active']"
      v-bind:notDisplayedFields="['id', 'customerId']"
      v-bind:addLinkToDetails="false"
      v-bind:defaultValues="{customer: `api/customers/${customerId}`}"/>
  </div>
</template>

<script>
import LicensesList from '../EntityList/LicensesList.vue';
import LicenseEntity from '../../store/entity/License';

export default {
  name: 'CustomerDetailsLicenses',
  components: { LicensesList },
  data() {
    return {
      licenseEntity: LicenseEntity,
      customerName: '',
    };
  },
  computed: {
    customerId() {
      return this.$route.params.id;
    },
  },
  methods: {
    getCustomerName() {
      this.$http.get(`/api/customers/${this.customerId}`).then((response) => {
        this.customerName = response.data.name;
        this.$store.commit('setCustomPageTitle', `Licenses for ${this.customerName}`);
      });
    },
  },
  mounted() {
    this.$store.state.showCdLinks = true;
  },
  created() {
    this.getCustomerName();
  },
  destroyed() {
    this.$store.state.showCdLinks = false;
    this.$store.commit('clearCustomPageTitle');
  },
};
</script>

<style scoped>
.licenses {
  width: 100%
}
</style>
